import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import EditImg from "Images/profile/edit_icon.svg";
import { useEffect, useState } from "react";
import { useTracking } from "react-tracking";
import { EditProduct, ManageDelivery } from "Root/profile/utils/trackingEnums";
import { useHistory, useLocation } from "react-router-dom";
import toastService from "Root/profile/toastService";
import { subscriptionText } from "../constants";
import styles from "./styles.module.scss";
import ModifySnoozeOrderDrawer from "../ModifySnoozeOrderDrawer";
import RoundedGainfulButton from "../../common/RoundedGainfulButton";
import { useScreenWidth } from "../hooks";
import LargeFont from "../../common/LargeFont";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import { UpdateFutureOrdersThunk } from "Root/profile/redux/thunkCreators/orders/futureOrders";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import Tooltip from "@mui/material/Tooltip";
import info from "Images/checkout/info.svg";
import { useAppStore } from "Root/profile/lib/store";
const ModifyOrder = ({ reactivate }) => {
    const dispatch = useDispatch();
    const { subscriptions } = useAppStore();
    const ordersInfo = useSelector((state) => state.ordersInfo);
    const nextOrderDate = subscriptions[0]?.next_charge_scheduled_at;
    const showDelivery = useSelector((state) => state.ordersInfo.nextOrderDates.showCadenceFlexibility);
    const eligibleAdvantage = useSelector((state) => state.ordersInfo.nextOrderDates.eligibleAdvantage);
    const needsToProvidePauseReason = useSelector((state) => state.ordersInfo.nextOrderDates.needsToProvidePauseReason);
    const futureOrders = useSelector((state) => state.ordersInfo.futureOrders);
    const user = useSelector((state) => state.user);
    const isByb = user.user_class === "byb";
    const { plan } = ordersInfo.nextOrderDates;
    const history = useHistory();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth < 968;
    const { trackEvent } = useTracking();
    const unskipText = (_jsx("span", { children: "Un-skip your next order to update your preferred next order date." }));
    const unskipNextOrder = async () => {
        const copyFutureOrders = JSON.parse(JSON.stringify(futureOrders));
        const selectedFutureOrder = copyFutureOrders.find((item) => item.order_number.toString() === "1");
        const selectedFutureOrderIndex = 0;
        dispatch(setGlobalLoading(true));
        selectedFutureOrder.is_on = true;
        copyFutureOrders[selectedFutureOrderIndex] = selectedFutureOrder;
        await dispatch(UpdateFutureOrdersThunk(copyFutureOrders, 0, () => { }));
        dispatch(setGlobalLoading(false));
    };
    const trackEditNextOrderDateClick = () => {
        trackEvent({
            funComponent: EditProduct.EditOrderDate,
            event: `${ManageDelivery.Edit_nextOrderDate}`,
        });
    };
    const trackEditDeliveryFrequency = () => {
        trackEvent({
            funComponent: EditProduct.EditOrderDate,
            event: `${ManageDelivery.Edit_deliveryFrequency}`,
        });
    };
    const [openDrawer, setOpenDrawer] = useState(false);
    const [drawerState, setDrawerState] = useState({
        modify: false,
        cadence: false,
        plan_type: false,
    });
    const goToReactivate = () => {
        reactivate();
    };
    const clearDrawerState = () => {
        setDrawerState({
            modify: false,
            cadence: false,
            plan_type: false,
        });
        history.push("/app/subscription");
    };
    const { hash } = useLocation();
    useEffect(() => {
        if (hash === "#modify" && ordersInfo.nextOrderDates.nextShipmentYear) {
            setDrawerState({
                ...drawerState,
                modify: true,
            });
            setOpenDrawer(true);
        }
    }, [hash, ordersInfo]);
    const toggleDrawer = (value, field) => () => {
        if (!value) {
            clearDrawerState();
        }
        else if (field && value) {
            if (field === "modify") {
                trackEditNextOrderDateClick();
            }
            if (field === "cadence") {
                if (plan === "advantage") {
                    toastService.errorMessage("Please change to standard plan to change your delivery frequency");
                    return;
                }
                trackEditDeliveryFrequency();
            }
            setDrawerState({
                ...drawerState,
                [field]: true,
            });
        }
        if (!isMobile) {
            if (value) {
                const launcher = document.getElementById("launcher");
                if (launcher) {
                    launcher.style.bottom = "88px";
                }
            }
            if (!value) {
                const launcher = document.getElementById("launcher");
                if (launcher) {
                    launcher.style.bottom = "0px";
                }
            }
        }
        setOpenDrawer(value);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: [styles.modify_order, isByb && styles.byb].join(" "), children: [user.has_subscription && (_jsxs("div", { className: styles.modify_order_outer, children: [_jsx(LargeFont, { fontWeight: 400, children: subscriptionText.next_order_date }), _jsxs("div", { className: styles.modify_order_item, children: [_jsxs("div", { className: styles.skipdatecontain, children: [ordersInfo.nextOrderDates.nextOrderSkipped && (_jsx("p", { className: styles.skipped, children: "Skipped" })), _jsxs("span", { style: { display: "flex", alignItems: "center" }, children: [_jsx(LargeFont, { children: new Date(nextOrderDate).toLocaleDateString() }), ordersInfo.nextOrderDates.nextOrderSkipped && (_jsx(Tooltip, { title: unskipText, style: { background: "#F5F5F5" }, children: _jsx("img", { className: styles.skip_info, src: info, alt: "info" }) }))] })] }), ordersInfo.nextOrderDates.nextOrderSkipped ? (_jsx(UnderlinedButton, { "data-attr": "unskip-your-order-button", label: "Unskip", onClick: unskipNextOrder })) : isByb ? (_jsx("button", { className: styles.byb_edit_btn, onClick: toggleDrawer(true, "modify"), children: _jsx("img", { src: EditImg, alt: "" }) })) : (_jsx(UnderlinedButton, { "data-attr": "subscription-modify-your-order-button", label: "Edit", onClick: toggleDrawer(true, "modify") }))] })] })), user.has_subscription && eligibleAdvantage && !isByb && (_jsxs("div", { className: styles.modify_order_outer, children: [_jsx(LargeFont, { fontWeight: 400, children: subscriptionText.plan_type }), _jsxs("div", { className: styles.modify_order_item, children: [_jsx(LargeFont, { children: ordersInfo.nextOrderDates.plan }), _jsx(UnderlinedButton, { "data-attr": "subscription-modify-plan-type-button", label: "Edit", onClick: toggleDrawer(true, "plan_type") })] })] })), user.has_subscription && showDelivery && !isByb && (_jsxs("div", { className: styles.modify_order_outer, children: [_jsx(LargeFont, { fontWeight: 400, children: subscriptionText.delivery_frequency }), _jsxs("div", { className: styles.modify_order_item, children: [_jsx(LargeFont, { children: `Every ${ordersInfo.nextOrderDates.planCadence} ${ordersInfo.nextOrderDates.planCadenceType}` }), _jsx(UnderlinedButton, { "data-attr": "subscription-modify-your-cadence-button", label: "Edit", onClick: toggleDrawer(true, "cadence") })] })] })), !user.has_subscription && (_jsxs("div", { className: [
                            styles.modify_order_item,
                            styles.cancel_copy_wrapper,
                        ].join(" "), children: [_jsx("span", { className: styles.cancelled_copy, children: _jsx(LargeFont, { fontWeight: 400, children: "Cancelled" }) }), _jsx(RoundedGainfulButton, { label: "Reactivate", onClick: goToReactivate, extraClassName: styles.cancel_subscription_btn, "data-attr": "subscription-reactivate-button" })] }))] }), _jsx(ModifySnoozeOrderDrawer, { fromSkipOrder: 0, toggleDrawer: toggleDrawer, openDrawer: openDrawer, isModify: drawerState.modify, isDeliveryCadence: drawerState.cadence, isPlanType: drawerState.plan_type, needsToProvidePauseReason: needsToProvidePauseReason })] }));
};
export default ModifyOrder;
